angular.module('impactx.sidebar').controller('MenuSidebarToggleCtrl', [
    'sidebarShow',
    MenuSidebarToggleController
]);

function MenuSidebarToggleController(sidebarShow) {
    var self = this;
    sidebarShow.open();

    self.toggleMenuSidebar = function () {
        sidebarShow.toggle();
    };

    self.isOpen = function () {
        return sidebarShow.isOpen();
    };
}